import React from "react";
import styles from "./ToiPageHeader.module.css";

function ToiPageHeader({
  logo,
  logoAlt = "",
  onBack = () => {},
  rightContent = null,
  theme = "light",
  showBackButton = true,
}) {
  return (
    <>
      <div className={styles.headerSpacer} aria-hidden="true" />
      <header className={styles.brandBar} data-theme={theme}>
        <div className={styles.brandCluster}>
          {showBackButton ? (
            <button
              type="button"
              className={styles.backButton}
              onClick={onBack}
              aria-label="Go back"
            >
              <span className={styles.backArrow} />
            </button>
          ) : null}

          {logo ? (
            <img src={logo} alt={logoAlt} className={styles.headerLogo} />
          ) : null}
        </div>

        {rightContent ? (
          <div className={styles.headerRight}>{rightContent}</div>
        ) : null}
      </header>
    </>
  );
}

export default ToiPageHeader;
